import React from 'react';
import { QuestionnaireView } from './useGetLastQuestionnaireByPatientCodexId';
import { twMerge } from 'tailwind-merge';

export interface Allergens extends QuestionnaireView {
  answer: string[];
  title: string;
}

interface AllergensBlockProps {
  questionnaire: Allergens[];
  className?: string;
}

const AllergensBlock: React.FC<AllergensBlockProps> = ({
  questionnaire = [],
  className,
}) => {
  const { title, answer } = questionnaire[0] || {};

  if (
    !questionnaire.length ||
    !questionnaire?.[0]?.answer?.filter((stringResponse) => !!stringResponse)
      ?.length
  ) {
    return (
      <div className="flex flex-col mt-5 gap-2.5">
        <div className="self-stretch justify-start text-neutral-800 font-semibold leading-normal">
          {title}
        </div>
        <div className="self-stretch inline-flex flex-col justify-start items-start gap-2.5">
          <div className="self-stretch justify-start text-med-gray-3 text-base font-medium  leading-snug">
            None
          </div>
        </div>
      </div>
    );
  }

  const med = (answer || []).map((str) => JSON.parse(str));

  return (
    <div className={twMerge('flex flex-col gap-2.5 mt-5', className)}>
      {med.map(({ label, value, reaction }) => {
        const reactions = Array.isArray(reaction) ? reaction : [reaction];
        return (
          <div key={`${value}`} className="grid grid-cols-2 gap-5">
            <div className="col-span-1 flex flex-col gap-2.5">
              <div className="text-neutral-800 font-semibold leading-normal">
                {title}
              </div>
              <div className="text-med-gray-3 text-base font-medium leading-snug">
                {label}
              </div>
            </div>

            <div className="col-span-1 flex flex-col gap-2.5">
              <div className="text-neutral-800 font-semibold leading-normal">
                Allergic reactions
              </div>
              <div className="text-med-gray-3 text-base font-medium leading-snug">
                {reactions.join(', ')}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AllergensBlock;
